import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex flex-wrap gap-y-4 px-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      class: "px-4",
      label: "Kriteria Berkas"
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "Tipe Berkas",
        class: "w-full capitalize",
        value: _ctx.detailData.commissionArchiveType
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Nama Aktivitas",
        class: "w-6/12 capitalize",
        value: _ctx.detailData.commissionActivityName
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Deskripsi",
        class: "capitalize w-6/12",
        value: _ctx.detailData.commissionDescription
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Sumber Booking",
        class: "capitalize w-6/12",
        value: _ctx.commissionBookingSource
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Komisi Untuk",
        class: "capitalize w-6/12",
        value: _ctx.detailData.commissionFor
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Shipment ID",
        class: "w-full"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.commissionShipmentId, (item, index) => {
            return (_openBlock(), _createBlock("div", { key: index }, [
              (item.name === '')
                ? (_openBlock(), _createBlock("div", _hoisted_3, "-"))
                : (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(item.name) + " (" + _toDisplayString(item.prefix) + ")", 1))
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _hoisted_5
  ]))
}